import { appstr } from "@coreapp/utils/appstr";

export const ScimSamlConflictBanner = ({ visible }) => {
  if (!visible) return null;
  return (
    <div className="oc-scim-saml-conflict-banner" role="alert">
      <strong>{appstr("SCIMSAMLConflictTitle")}</strong>
      <p>{appstr("SCIMSAMLConflictBody")}</p>
    </div>
  );
};
